





























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { mdiArrowRight } from '@mdi/js'
import { ISliderItemContent } from '~/assets/interfaces/slider'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentSliderContent extends mixins(MixinGeneral) {
  @Prop({ type: Object, required: true }) readonly content!: ISliderItemContent
  // Слайд высокий (почти квадрат и выше) — на мобильной вёрстке можно вернуть
  // нормальный размер шрифта вместо ужатого.
  @Prop({ type: Boolean, default: false }) readonly tall!: boolean

  private mdiArrowRight = mdiArrowRight

  private get hasButton() {
    return Boolean(this.content.button && this.content.button.text)
  }

  private get classPosition() {
    const position = this.content.position || 'left'
    return {
      [this.$style.positionLeft]: position === 'left',
      [this.$style.positionCenter]: position === 'center',
      [this.$style.positionRight]: position === 'right',
    }
  }

  private get classTheme() {
    return {
      [this.$style.themeLight]: this.content.theme === 'light',
      [this.$style.themeDark]: this.content.theme !== 'light',
    }
  }
}
